// The threshold (in yards) at which proximity is described in miles rather than yards
export const YARDS_TO_MILES_THRESHOLD = 1760
// The threshold (in meters) at which proximity is described in km rather than meters
export const METERS_TO_KM_THRESHOLD = 1000
// The default radius to use for proximity queries
export const DEFAULT_RADIUS_METERS = 25000
